export function getFullname (user) {
  if (user == null) return ''

  return [
    user.roles?.includes('love') && '❤️',
    user.name,
    user.surname,
    user.midname
  ]
    .filter(Boolean)
    .join(' ')
}
